/** W14 View Transaction Details (Progress Status → View; manual p258, screenshot 154043). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { GotTransactionDetailsPage } from "@/features/got/components/result-update-pages";

export const Route = createFileRoute(
  "/_app/quality/got/result-update/$sampleId/view"
)({
  beforeLoad: () => {
    if (!useAuth.getState().can("got.result_update"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { sampleId } = Route.useParams();
  return <GotTransactionDetailsPage sampleId={Number(sampleId)} />;
}
